import { ChainId, SDK } from '@cronos-app/sdk';
import { getAddEthereumChainParameter } from '@cronos-app/wallet';

const genSDK = (
  chainId: ChainId
 ) => {
  const { chainName, rpcUrls } = getAddEthereumChainParameter(chainId);
  const rpcUrl = rpcUrls[0];
  return new SDK({
    providerOptions: {
      chainName: chainName,
      chainId,
      rpcUrl,
    },
  });
};

const SDK_BY_CHAIN = {
  [ChainId.CRONOS_MAINNET]: genSDK(ChainId.CRONOS_MAINNET),
  [ChainId.CRONOS_TESTNET]: genSDK(ChainId.CRONOS_TESTNET),
};

export const getSDK = (chainId: ChainId) => SDK_BY_CHAIN[chainId];
